var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgForumLogoRotating = function SvgForumLogoRotating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 183.45 183.45",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    id: "ForumLogoRotating_svg__Layer_1",
    style: {
      height: "100%",
      width: "100%",
      background: "0 0",
      shapeRendering: "crispedges"
    },
    width: 171,
    height: 171
  }, props), /*#__PURE__*/React.createElement("g", {
    className: "ForumLogoRotating_svg__ldl-scale",
    style: {
      transformOrigin: "50% 50%",
      transform: "rotate(0deg) scale(.8,.8)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ForumLogoRotating_svg__ldl-ani",
    style: {
      transformOrigin: "91.725px 91.725px",
      transform: "rotate(0deg)",
      animation: "1.11111s linear 0s infinite normal forwards running spin-81c3b84d-6bf8-4805-9938-eca3a2e85cc8"
    }
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "@keyframes spin-81c3b84d-6bf8-4805-9938-eca3a2e85cc8{0%{animation-timing-function:cubic-bezier(.5856,.0703,.4143,.9297);transform:rotate(0deg)}to{transform:rotate(360deg)}}.ForumLogoRotating_svg__cls-2{fill:#42efcc}.ForumLogoRotating_svg__cls-4{fill:#49caf4}"))), /*#__PURE__*/React.createElement("g", {
    className: "ForumLogoRotating_svg__ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ForumLogoRotating_svg__ldl-ani"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.72 114v20.41c-30.35 0-55-23.93-55-53.44a52.74 52.74 0 0 1 1-10.2C42.66 95.37 65 114 91.72 114Z",
    className: "ForumLogoRotating_svg__cls-2",
    style: {
      fill: "#42efcc"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ForumLogoRotating_svg__ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ForumLogoRotating_svg__ldl-ani"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.69 80.94v1.63c-1.17 49.17-54.94 72.22-54.94 72.22v-20.41s47.06-20.17 54.08-63a52.31 52.31 0 0 1 .86 9.56Z",
    className: "ForumLogoRotating_svg__cls-2",
    style: {
      fill: "#42efcc"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ForumLogoRotating_svg__ldl-layer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.06 61.81C130.8 97.22 91.72 114 91.72 114V93.57a55 55 0 0 1-50.81-33 55 55 0 0 1 50.81-33c23.42-.07 43.43 14.18 51.34 34.24Z",
    style: {
      fill: "#2564f2"
    },
    className: "ForumLogoRotating_svg__ldl-ani"
  })), /*#__PURE__*/React.createElement("g", {
    className: "ForumLogoRotating_svg__ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ForumLogoRotating_svg__ldl-ani"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.72 93.57V114c-26.76 0-49.06-18.6-54-43.23a52.48 52.48 0 0 1 3.15-10.2 55 55 0 0 0 50.85 33Z",
    className: "ForumLogoRotating_svg__cls-4",
    style: {
      fill: "#49caf4"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ForumLogoRotating_svg__ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ForumLogoRotating_svg__ldl-ani"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.8 71.35c-7 42.86-54.08 63-54.08 63V114s39.08-16.75 51.34-52.16a51.75 51.75 0 0 1 2.74 9.51Z",
    className: "ForumLogoRotating_svg__cls-4",
    style: {
      fill: "#49caf4"
    }
  }))))));
};
export default SvgForumLogoRotating;